import { render, staticRenderFns } from "./LmPrefixes.vue?vue&type=template&id=f800cd9c"
import script from "./LmPrefixes.vue?vue&type=script&lang=js"
export * from "./LmPrefixes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports